import React, { Component } from "react";
import moment from "moment";
import less from "../search.module.scss";
import { Select, message, DatePicker } from "antd";
import Fetch from "../../../utils/fetch";
const { RangePicker } = DatePicker;
const { Option } = Select;
class OperatorSearch extends Component {
  state = {
    rcs: [],
    busHosts: [],
    buttonLoading: false,
    fromDate: moment()
      .startOf("day")
      .valueOf(),
    toDate: moment()
      .endOf("day")
      .valueOf(),
    hackValue: undefined,
    calendarDates: null
  };

  async componentDidMount() {
    try {
      const [rcs, busHosts] = await Promise.all([
        this.fetchBusRc(),
        this.fetchBusHosts()
      ]);
      this.setState({ rcs, busHosts });
    } catch (err) {
      message.error(err);
    }
  }

  async fetchBusRc() {
    try {
      const url = `/bus-tracker/getBusRc`;

      const options = {
        method: "get"
      };
      const response = await Fetch(url, options);
      if (response) {
        return response;
      } else {
        return [];
      }
    } catch (err) {
      console.log(err);
      return [];
    }
  }

  async fetchBusHosts() {
    try {
      const url = `/workAuditHistory/busHosts`;
      const options = { method: "get" };
      const response = await Fetch(url, options);
      if (response && Array.isArray(response)) {
        return response;
      } else {
        return [];
      }
    } catch (err) {
      console.log(err);
      return [];
    }
  }

  search = async () => {
    try {
      const { busRc, closedByUserId, fromDate, toDate } = this.state;
      let body = {};
      const url = `/workAuditHistory/fetchAudit`;
      if (busRc) {
        body.busRc = busRc;
      }
      if (closedByUserId) {
        body.closedByUserId = closedByUserId;
      }
      if (fromDate && toDate) {
        body.fromDate = fromDate.valueOf();
        body.toDate = toDate.valueOf();
      }
      if ((fromDate && !toDate) || (toDate && !fromDate)) {
        message.error("please select both date");
        return;
      }
      const options = {
        method: "post",
        data: body
      };
      const response = await Fetch(url, options);

      this.props.fetched(response);
    } catch (err) {
      console.log(err);
      this.props.fetched([]);
    }
  };

  onOpenChange = open => {
    if (open) {
      this.setState({ hackValue: [null, null], calendarDates: null });
    } else {
      this.setState({ hackValue: undefined });
    }
  };

  onCalendarChange = dates => {
    this.setState({ calendarDates: dates || null });
  };

  disabledDate = current => {
    const { calendarDates } = this.state;

    if (!calendarDates || !calendarDates[0]) {
      return false;
    }

    const start = calendarDates[0];

    return (
      current.isBefore(start.clone().subtract(29, "days"), "day") ||
      current.isAfter(start.clone().add(29, "days"), "day")
    );
  };

  onTimeRangeSelect = dates => {
    if (!dates) {
      this.setState({
        fromDate: moment()
          .startOf("day")
          .valueOf(),
        toDate: moment()
          .endOf("day")
          .valueOf(),
        hackValue: undefined,
        calendarDates: null
      });
      return;
    }

    this.setState({
      fromDate: dates[0].startOf("day").valueOf(),
      toDate: dates[1].endOf("day").valueOf(),
      hackValue: undefined,
      calendarDates: null
    });
  };

  render() {
    const {
      buttonLoading,
      busRc,
      rcs,
      busHosts,
      closedByUserId,
      fromDate,
      toDate,
      hackValue
    } = this.state;
    return (
      <div className={less.auditSearch}>
        <span>Trip start audit review screen</span>
        <div className={less.selectables}>
          <div className={less.dateSelect}>
            <RangePicker
              allowClear
              value={hackValue !== undefined ? hackValue : [moment(fromDate), moment(toDate)]}
              format="YYYY-MM-DD"
              onOpenChange={this.onOpenChange}
              onChange={this.onTimeRangeSelect}
              onCalendarChange={this.onCalendarChange}
              disabledDate={this.disabledDate}
            />
          </div>
          <Select
            allowClear
            placeholder="Bus Rc"
            showSearch
            style={{ width: 320 }}
            value={busRc}
            onChange={value =>
              this.setState({
                busRc: value
              })
            }
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            {rcs.map(s => (
              <Option value={s.rc} key={s._id}>
                {s.rc}
              </Option>
            ))}
          </Select>
          <Select
            allowClear
            placeholder="Bus Host"
            showSearch
            style={{ width: 320 }}
            value={closedByUserId}
            onChange={value => this.setState({ closedByUserId: value })}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            {busHosts.map(host => (
              <Option value={host._id} key={host._id}>
                {`${host.name} - ${host.mobileNo}`}
              </Option>
            ))}
          </Select>
          <button
            disabled={buttonLoading}
            className={less.searchBtn}
            onClick={this.search}
          >
            <span>Search</span>
          </button>
        </div>
      </div>
    );
  }
}

export default OperatorSearch;
